import { render, staticRenderFns } from "./MessagesPageContainer.vue?vue&type=template&id=698bb4e0&"
import script from "./MessagesPageContainer.vue?vue&type=script&lang=js&"
export * from "./MessagesPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports